export default "__VITE_ASSET__CTZWP$vw__"